import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {ReferentielTypePieceListPage} from './ReferentielTypePieceListPage'
import {ReferencementTypePieceEditPage} from './ReferencementTypePieceEditPage'

const ReferentielTypePieceWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Gestion des types pièces</PageTitle>
              <ReferentielTypePieceListPage />
            </>
          }
        />
        <Route
          path=':referentielTypePieceId/modifier/:typePieceId'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Gestion des types pièces', path: '/referentiel-type-piece', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <ReferencementTypePieceEditPage />
            </>
          }
        />

        <Route index element={<Navigate to='/referentiel-type-piece/liste' />} />
      </Routes>
    </>
  )
}

export {ReferentielTypePieceWrapper}
